import Header from '../components/Header'
import Hero from './Hero'
import StoryCarousel from './StoryCarousel'
import Features  from './Features'
import Testimonials  from './Testimonials'
import CTA  from './CTA'
import Footer  from '../components/Footer'

export default function LandingPage() {
    return (
        <div className="min-h-screen bg-white text-slate-900">
            <Header />
            <main>
                <Hero />
                <StoryCarousel />
                <Features />
                <Testimonials />
                <CTA />
            </main>
            <Footer />
        </div>
    )
}
